import BaseApi from './BaseApi'

class AdviserRatingApi extends BaseApi {
  get adviserRatingsUrl () {
    return 'adviserRatings'
  }
  postAdviserRating (adviserRating) {
    return this.postJson(this.adviserRatingsUrl, adviserRating)
  }
}
export default AdviserRatingApi
